import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SWService } from '@fry/lib/utils';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {


  async ngOnInit() {
    console.info('AppComponent:: initial navigation');
  };

  constructor(
    private swservice: SWService,
    // private config: ConfigService
  ) {
    this.swservice.logSelf();

    // this.auth.currentUser().subscribe(user => {
    //   const license = this.config.server.liveChat?.licenses[user.organisation];
    //   if (license) {
    //     window['__lc'] = window['__lc'] || {};
    //     window['__lc'].license = license;
    //     var startChat = function() {
    //       var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
    //       lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
    //       var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
    //     };
    //     startChat();
    //   }
    // });

  }
}
